import React from "react";
import { Table } from "antd";

export const markdownComponents = {
  h1({ children }: any) {
    return (
      <h1 className="text-lg font-semibold text-gray-900 mt-2 mb-2 pb-1 border-b border-gray-100">
        {children}
      </h1>
    );
  },
  h2({ children }: any) {
    return (
      <h2 className="text-base font-semibold text-gray-800 mt-4 mb-1 border-b border-gray-100 pb-1 mt-5">
        {children}
      </h2>
    );
  },
  h3({ children }: any) {
    return (
      <h3 className="text-sm font-semibold text-gray-700 mt-2 mb-1 mt-3">
        {children}
      </h3>
    );
  },
  p({ children }: any) {
    return (
      <p className="text-sm font-normal text-gray-600 leading-relaxed mb-1">
        {children}
      </p>
    );
  },
  strong({ children }: any) {
    return <span className="font-normal text-gray-700">{children}</span>;
  },
  hr() {
    return null; // remove all hr lines
  },
  ul({ children }: any) {
    return (
      <ul className="list-disc list-outside pl-5 mb-2 space-y-0.5">
        {children}
      </ul>
    );
  },
  ol({ children }: any) {
    return (
      <ol className="list-decimal list-outside pl-5 mb-2 space-y-0.5">
        {children}
      </ol>
    );
  },
  li({ children }: any) {
    return (
      <li className="text-sm font-normal text-gray-600 leading-relaxed">
        {children}
      </li>
    );
  },
  table({ children }: any) {
    let headers: string[] = [];
    let rows: string[][] = [];

    React.Children.forEach(children, (section: any) => {
      if (section?.type === "thead") {
        const headerRow = section.props.children;
        headers = React.Children.map(headerRow.props.children, (th: any) =>
          typeof th.props.children === "string"
            ? th.props.children
            : (th.props.children?.props?.children ?? ""),
        );
      }
      if (section?.type === "tbody") {
        React.Children.forEach(section.props.children, (tr: any) => {
          const cells = React.Children.map(tr.props.children, (td: any) =>
            typeof td.props.children === "string"
              ? td.props.children
              : (td.props.children?.props?.children ?? ""),
          );
          rows.push(cells);
        });
      }
    });

    const columns = headers.map((header, i) => ({
      title: (
        <span className="text-xs font-normal text-gray-600">{header}</span>
      ),
      dataIndex: `col_${i}`,
      key: `col_${i}`,
      align: i > 0 ? ("right" as const) : ("left" as const),
      render: (val: string) => (
        <span className="text-xs font-normal text-gray-700">{val}</span>
      ),
    }));

    const dataSource = rows.map((row, rowIndex) => ({
      key: rowIndex,
      ...Object.fromEntries(
        row.map((cell, colIndex) => [`col_${colIndex}`, cell]),
      ),
    }));

    return (
      <div className="my-2 rounded-md overflow-hidden border border-gray-200">
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          size="small"
          bordered={false}
        />
      </div>
    );
  },
};
